/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { NbIconLibraries } from '@nebular/theme';

// dsd
@Component({
  selector: 'ngx-app',
  template: '<router-outlet></router-outlet>',
})
export class AppComponent implements OnInit {
  constructor(iconsLibrary: NbIconLibraries) {
    iconsLibrary.registerFontPack('fa', {
      packClass: 'fa',
      iconClassPrefix: 'fa',
    });
    iconsLibrary.registerFontPack('far', {
      packClass: 'far',
      iconClassPrefix: 'fa',
    });
    iconsLibrary.registerFontPack('ion', { iconClassPrefix: 'ion' });
  }

  ngOnInit(): void {
    // this.analytics.trackPageViews();
    // const OneSignal = window['OneSignal'] || [];
    // OneSignal.push(['init', {
    //   appId: 'eb2e3802-a47c-4061-a665-bf534e992a6b',
    //   autoRegister: false,
    //   allowLocalhostAsSecureOrigin: true,
    //   notifyButton: {
    //     enable: true
    //   },
    // }]);
    // OneSignal.setSubscription(true);
  }
}
